import { useCallback } from 'react';
import useHankoAuth from './useHankoAuth';
import { trackAppEvent, trackAppEventOnce } from '../analytics/trackEvent';
import { buildTrackingMeasurementContext } from '../analytics/measurementContext';

const useAppTracking = () => {
    const { user, measurementContext, isInternalMeasurementUser } = useHankoAuth();

    const getContext = useCallback(() => (
        buildTrackingMeasurementContext(user, measurementContext, isInternalMeasurementUser)
    ), [isInternalMeasurementUser, measurementContext, user]);

    const trackEvent = useCallback((eventName, properties = {}) => (
        trackAppEvent(eventName, properties, getContext())
    ), [getContext]);

    const trackEventOnce = useCallback((key, eventName, properties = {}) => (
        trackAppEventOnce(key, eventName, properties, getContext())
    ), [getContext]);

    return {
        trackEvent,
        trackEventOnce
    };
};

export default useAppTracking;
